import { JSF32RandomIDGenerator } from '@tencent/slide-sdk-model';

const idGenerator = new JSF32RandomIDGenerator();

export function uuid() {
  return idGenerator.next();
}

/**
 * 根据 URL 判断图片类型
 * @param {*} url 图片 url
 */
export function getImageTypeByUrl(url) {
  const imageNameArr = url.split('?').shift().split('/').pop().split('.');
  return imageNameArr.length === 2 ? imageNameArr[1] : '';
}

export function unescapeHTML(html: string): string {
  const htmlEntities: { [key: string]: string } = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#x2F;': '/',
    '&#x60;': '`',
    '&#x3D;': '=',
  };

  return html.replace(/&amp;|&lt;|&gt;|&quot;|&#39;|&#x2F;|&#x60;|&#x3D;/g, (match) => {
    return htmlEntities[match];
  });
}

export function parseJson<T = any>(jsonStr: string): T | null {
  try {
    return JSON.parse(jsonStr);
  } catch (error) {
    return null;
  }
}
